import { createContext, useContext } from 'react'

export const DashboardContext = createContext({
  selectedParameters: [],
  // Sites + active project id, shared so widgets that need project-scoped
  // data (e.g. the GPS widget on the Project Map dashboard) can read it
  // without prop-drilling through the widget registry.
  sites: [],
  projectId: null,
  dateRange: { from: '', to: '' },
  activePeriod: 'D',
  handlePeriodClick: () => {},
  setDateRange: () => {},
  isCustomizing: false,   // true when dashboard is in Customize/edit mode
  // Switch to the Gallery tab. Optional `albumName` deep-links to a specific
  // album sub-tab so widgets (e.g. Gallery, Project Photo) can open a
  // particular album rather than just landing on the Gallery root.
  goToGallery: (_albumName) => {},
})

export const useDashboardContext = () => useContext(DashboardContext)
